import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import * as colors from '../../../common/styles/colors';
import { ButtonPrimary, Icon } from '../../../common/components';
import moment from 'moment';
import { useAuthState } from '../../../providers/authProvider';
import { TagManager } from '../../utils/analytics/TagManager';
import { downloadBackingDataReport } from '../../../common/api/ersGatewayAdapterApi';
import { isTpiUser } from '../../../helpers/tpiUser';

type InvoiceBackingDataSuccessModalProps = {
  show: boolean;
  onHide: () => void;
  onError: () => void;
  messagevalues: Messages.IMessagesValues;
};

const defaultProps = {
  show: true,
};

const InvoiceBackingDataSuccessModalWrapper = styled.div``;

export const InvoiceBackingDataSuccessModal = (props: InvoiceBackingDataSuccessModalProps) => {
  const authContext = useAuthState();
  const claims = authContext.getClaims();

  const obj = props.messagevalues.json;

  const requestId = obj.RequestId;
  const accountReference = obj.AccountReference;
  const requestDateTime = moment(obj.RequestDateTime);

  const title = 'Invoice backing data success Excel format';
  const messageTop = `The data you requested for account ${accountReference} on ${requestDateTime.format(
    'DD MMM YYYY'
  )} is now ready to download.`;

  const handleDownloadExcel = async (e: any) => {
    e.preventDefault();

    TagManager.pushData({
      event: 'Download Invoice backing data excel',
      userType: isTpiUser() ? 'TPI User' : 'Customer',
      customerAccountReference: isTpiUser() ? `${accountReference}/${claims.tpiReferenceId}` : `${accountReference}`,
    });

    const result = downloadBackingDataReport(process.env.REACT_APP_API_URL, authContext, requestId);
    result
      .then((result: any) => {
        props.onHide();
      })
      .catch((error: any) => {
        props.onError();
      });
  };

  return (
    <InvoiceBackingDataSuccessModalWrapper>
      <Modal.Header style={{ justifyContent: 'center', textAlign: 'center' }}>
        <Modal.Title>
          <span className='pr-4 float-left'>
            <Icon color={colors.draxBtn} size={50} icon='download2' />
          </span>
          <div className='text-center'>{title}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ justifyContent: 'center', textAlign: 'center' }}>
        <p>{messageTop}</p>
      </Modal.Body>
      <Modal.Footer className='p-0'>
        <div className='d-flex justify-content-end'>
          <ButtonPrimary className='m-0' title='Excel' onClick={handleDownloadExcel} />
        </div>
      </Modal.Footer>
    </InvoiceBackingDataSuccessModalWrapper>
  );
};

InvoiceBackingDataSuccessModal.defaultProps = defaultProps;
